import { render } from "./MenuEngineeringCategory.vue?vue&type=template&id=22145461&scoped=true&ts=true"
import script from "./MenuEngineeringCategory.vue?vue&type=script&lang=ts"
export * from "./MenuEngineeringCategory.vue?vue&type=script&lang=ts"

import "./MenuEngineeringCategory.vue?vue&type=style&index=0&id=22145461&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22145461"]])

export default __exports__